// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar__Sidebar__uuhcG","Minify":"Sidebar__Minify__2IOUb","ToggleButtonSection":"Sidebar__ToggleButtonSection__2TIM5","Open":"Sidebar__Open__ii3Jv","fadeIn":"Sidebar__fadeIn__3p2T1","Current":"Sidebar__Current__O7CLO","fadeOut":"Sidebar__fadeOut__9fmqU","IconItem":"Sidebar__IconItem__13bBT","status":"Sidebar__status__qqI1N","users":"Sidebar__users__3wjWB","barChains":"Sidebar__barChains__vhLl7","bars":"Sidebar__bars__2QN4o","equipment":"Sidebar__equipment__2Czbg","menu":"Sidebar__menu__3htt1","orders":"Sidebar__orders__6uv_Z","statistics":"Sidebar__statistics__185cJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/Sidebar/Sidebar.css
// module id = 285
// module chunks = 6